/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recover_InvalidInputs */

const en_recover_invalid = /** @type {(inputs: Recover_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code is not valid or was already used.`)
};

const de_recover_invalid = /** @type {(inputs: Recover_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Code ist ungültig oder wurde schon verwendet.`)
};

/**
* | output |
* | --- |
* | "That code is not valid or was already used." |
*
* @param {Recover_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recover_invalid = /** @type {((inputs?: Recover_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recover_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recover_invalid(inputs)
	return en_recover_invalid(inputs)
});